import swal from "sweetalert2";

export async function confirmSessionRefreshRetry(retrySessionRefresh, options = {}) {
	const retryMessage = options.willRetryAutomatically
		? "We will keep trying automatically. You can also click below to try again now."
		: "Click below to try again.";

	try {
		const result = await swal.fire({
			title: "Session refresh failed",
			html: `Your session could not be refreshed. This can happen during a brief network interruption, or if your device clock is not set correctly.
					<br/>
					<br/>
					${retryMessage}`,
			showCloseButton: false,
			type: "warning",
			showCancelButton: false,
			confirmButtonColor: "#8CC541",
			confirmButtonText: "Retry",
			allowOutsideClick: false,
			allowEscapeKey: false,
			showLoaderOnConfirm: true,
			preConfirm: async() => {
				try {
					await retrySessionRefresh();

					return true;
				}
				catch{
					return false;
				}
			}
		});

		return !result.dismiss;
	}
	catch{
		return false;
	}
}

export function closeSessionRefreshRetryPrompt() {
	swal.close();
}
